<template>
  <!-- eslint-disable -->
  <div class="TOSHtml">
    <div style="text-align: center">
      <h2>TERM OF SERVICES</h2>
    </div>
    <ol>
      <li id="term_overview">
        <h3>OVERVIEW</h3>
        <ol>
          <li>
            <p>
              The website
              <a target="_blank" href="https://www.communitylearninghub.ca">(https://www.communitylearninghub.ca)</a> is
              operated by Operation Springboard.
            </p>
          </li>
          <li>
            <p>
              This website is referred to variously in this document as “HUB Website”; or “this Website”; or “this
              Site”; “the Site”; “our Site”; “our Website”; or “the Service(s)”; or “Service(s)”; or “our Service(s)”;
              or “your Service(s)”.
            </p>
          </li>
          <li>
            <p>Throughout these Terms of Service, the terms “we”, “us” and “our” refer to Springboard.</p>
          </li>
          <li>
            <p>
              Springboard offers the HUB Website, including all information, tools and services available from this Site
              to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated
              here.
            </p>
          </li>
          <li>
            <p>
              Please read these Terms of Service and the HUB Privacy Policy carefully before accessing or using our
              Website. By accessing or using any part of the Site, you agree to be bound by these Terms of Service and
              the HUB Privacy Policy. If you do not agree to all the terms and conditions of this agreement, then you
              may not access the Website or use any of its Services.
            </p>
          </li>
          <li>
            <p>
              The headings used in this agreement are included for convenience only and will not limit or otherwise
              affect these Terms of Service.
            </p>
          </li>
        </ol>
      </li>

      <li id="web_term">
        <h3>WEBSITE TERMS</h3>
        <ol>
          <li>
            <p>
              Where: (a) an individual is an employee of a non-profit agency, social sector service, or civic
              institution; and where (b) that organization is in the official business of delivering health promotion,
              harm prevention and/or harm reduction services to a vulnerable population; and where (c) that organization
              delivers its services to that population without profit; and where (d) an employee of that organization
              wishes to use the HUB Website for the exclusive purposes of his/her own professional development as a
              social service worker, and to deliver health-promotion/harm-prevention skill development programming to
              his/her organization’s clients; and where (e) that employee covenants to deliver HUB programming to
              his/her organization’s clients without charge whatsoever and in full accordance with his/her
              organization’s policies and procedures and any federal, provincial, and municipal statutes, bylaws and
              regulations governing such practices; and where (f) that individual has accepted these Terms of Service
              and the HUB Privacy Policy;
              <strong>
                <i
                  >then that individual will be considered by Springboard “eligible” to access and utilize the HUB
                  Website.</i
                >
              </strong>
            </p>
          </li>
          <li>
            <p>
              Notwithstanding Section 2.1, Springboard reserves the right to: (a) confirm the eligibility of any person
              applying for a HUB Website account; and (b) confirm or reconfirm the eligibility of any person already in
              possession of a HUB Website account; and (c) refuse Service to anyone for any reason at any time.
            </p>
          </li>
          <li>
            <p>
              There is no direct cost for Ontario based non-profit agencies working with in-need/at-risk individuals to
              access the Community Learning HUB Website.
            </p>
          </li>
          <li>
            <p>
              When applying to Springboard for a HUB Website account you must: (a) use your work contact information
              from the said organization described above in section 2.1.; and (b) not use a false e-mail address and/or
              pretend to be someone other than yourself; and (c) immediately inform Springboard should your tenure at
              the said organization terminate.
            </p>
          </li>
          <li>
            <p>
              Login credentials issued to you by Springboard may only be used by you and not shared with other persons,
              even within the same organization.
            </p>
          </li>
          <li>
            <p>
              You are responsible for maintaining the security of your HUB user's account and password. We are not
              liable for any claims, losses, damages, suits or proceedings relating to the sharing of your user account
              and/or password with others. You agree to notify Springboard immediately after you become aware of any
              unauthorized use of your user account and/or password, and to take such reasonable steps as are necessary
              to prevent any reoccurrence of such event.
            </p>
          </li>
          <li>
            <p>
              You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the HUB Website, use
              of the Service, or access to the Service or any contact on the Website through which the Service is
              provided, without express written permission by us.
            </p>
          </li>
          <li>
            <p>
              You are responsible for all data uploaded to the HUB Website and all activity that occurs under your
              account.
            </p>
          </li>
          <li>
            <p>
              You are solely responsible for the accuracy of any data you upload to the Site. We take no responsibility
              and assume no liability for the accuracy of data uploaded by you or any third party.
            </p>
          </li>
          <li>
            <p>
              We cannot and will not be liable for any loss or damage from your failure to comply with these Terms of
              Service.
            </p>
          </li>
          <li>
            <p>
              <strong
                >A breach or violation of any of these Terms will result in an immediate termination of your
                Services.</strong
              >
            </p>
          </li>
        </ol>
      </li>

      <li id="team_select">
        <h3>HUB TEAM SELECTION</h3>
        <ol>
          <li>
            <p>
              Once you have acquired individual log-in credentials for the HUB Website, you will have access to all of
              the Site’s content; however, you will only be able to use the content
              <span class="underline">as an individual facilitator</span> and, as such, will not have any access to the
              HUB’s “TEAM” functions. Without belonging to a HUB Team, you would not be able to deliver HUB programming
              to clients registered to the HUB Website by another facilitator (i.e.: a co-worker).
            </p>
          </li>
          <li>
            <p>
              <strong>
                <i
                  >Facilitators belonging to the same HUB team share a single
                  <span class="underline">Team Facilitator List </span> and a single
                  <span class="underline">Team Client List.</span></i
                >
              </strong>
            </p>
            <ol>
              <li>
                <p>
                  A shared <span class="italic">Team Facilitator List</span> permits facilitators from the same HUB team
                  to train on HUB programs together and co-facilitate HUB programming to clients.
                </p>
              </li>
              <li>
                <p>
                  A shared <span class="italic">Team Client List</span> permits facilitators from the same HUB team to
                  work with clients registered by fellow team facilitators.
                </p>
              </li>
              <li>
                <p>
                  A shared <span class="italic">Team Client List</span> also permits facilitators from the same HUB team
                  to view the details of each client’s participation in HUB programming that had been delivered by a
                  facilitator affiliated with that team.
                </p>
              </li>
              <li>
                <p>
                  A representative from Springboard will be contacting the executive director (or designate) for your
                  agency to discuss whether or not your agency might benefit from HUB team affiliation and, if so, to
                  determine which facilitators should belong to which HUB team.
                </p>
              </li>
              <li>
                <p>
                  Please contact Springboard if you feel your HUB team designation is outstanding, or is not correct, or
                  needs to change for some reason.
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>

      <li id="accurate_completion">
        <h3>ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION</h3>
        <ol>
          <li>
            <p>
              We are not responsible if information made available on this Site is not accurate, complete or current.
              The material on this Site is provided for general information only and should not be relied upon or used
              as the sole basis for making decisions without consulting primary, more accurate, more complete or
              timelier sources of information. Any reliance on the material on this Site is at your own risk.
            </p>
          </li>
          <li>
            <p>
              This Site may contain certain historical information. Historical information, necessarily, is not current
              and is provided for your reference only. We reserve the right to modify the contents of this Site at any
              time, but we have no obligation to update any information on our Site. You agree that it is your
              responsibility to monitor changes to our Site.
            </p>
          </li>
        </ol>
      </li>

      <li id="service_modification">
        <h3>MODIFICATIONS TO THE SERVICES</h3>
        <ol>
          <li>
            <p>
              We reserve the right at any time to modify or discontinue the Service (or any part or content thereof)
              without notice at any time.
            </p>
          </li>
          <li>
            <p>
              We shall not be liable to you or to any third-party for any modification, suspension or discontinuance of
              the Service.
            </p>
          </li>
        </ol>
      </li>

      <li id="thirdParty_link">
        <h3>THIRD-PARTY LINKS</h3>
        <ol>
          <li>
            Certain content available via our Service may include materials from third parties or third party sites.
            Third party links on this Site may direct you to third party websites that are not affiliated with us. We
            are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not
            have any liability or responsibility for any third party materials or websites, or for any other materials
            of third parties. The inclusion of any information, material, content or links on the Site should not
            necessarily be construed as an express nor an implied endorsement of any third party products or services.
            Unless otherwise indicated, these third party sites are not maintained, operated or controlled by
            Springboard, and Springboard does not provide any guarantees regarding these third party sites. You assume
            sole liability for the use or access of such third party sites and/or content.
          </li>
        </ol>
      </li>

      <li id="user_submissions">
        <h3>USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS</h3>
        <ol>
          <li>
            <p>
              If, at our request, you send certain specific submissions or without a request from us you send creative
              ideas, suggestions, proposals, plans, or other materials, whether online, by email, by postal mail, or
              otherwise (collectively, 'comments'), you agree that we may, at any time, without restriction, edit, copy,
              publish, distribute, translate and otherwise use in any medium any comments that you forward to us. We are
              and shall be under no obligation (1) to maintain any comments in confidence; (2) to pay compensation for
              any comments; or (3) to respond to any comments. Any comments that you forward to us, whether requested or
              not, shall become the exclusive property of Springboard. By submitting such comments, you grant
              Springboard, its affiliates and assignees a worldwide, royalty-free, perpetual, irrevocable, exclusive
              right and license to use, reproduce, publish, republish, distribute, edit, store and archive such comments
              in whole or in part in any form or medium whatsoever, without liability or compensation of any sort. You
              further irrevocably waive any moral rights with respect to your comments in connection with our
              exploitation of the rights granted to us under these Terms of Service. You agree that Springboard shall be
              free to use any ideas, inventions, concepts, know-how or techniques in such comments for any purpose
              whatsoever, including but not limited to, developing products and services incorporating such comments. In
              forwarding to us comments, you knowingly and expressly agree with these terms and conditions.
            </p>
          </li>
          <li>
            <p>
              You agree that your comments will not violate any right of any third-party, including copyright,
              trademark, privacy, personality or other personal or proprietary right.
            </p>
          </li>
          <li>
            <p>
              When submitting comments to Springboard, you may not use a false e-mail address, pretend to be someone
              other than yourself.
            </p>
          </li>
          <li>
            <p>
              Springboard shall have no obligation to review or respond, in any manner, to said comments.
              Notwithstanding the foregoing, Springboard reserves the right to monitor, delete and/or refuse to
              transmit, move, or edit any material or information from the Site, in whole or in part, without notice to
              you that it deems in its sole discretion, unacceptable, undesirable or in violation of any law.
            </p>
          </li>
        </ol>
      </li>

      <li id="personal_information">
        <h3>PERSONAL INFORMATION</h3>
        <ol>
          <li>
            <p>
              Your submission of personal information through the website is governed by our Privacy Policy. You may
              view our Privacy Policy at:
              <a
                target="_blank"
                href="https://test.communitylearninghub.ca/hub-splash-2020/assets/HUB-Privacy-Policy.pdf"
                >https://test.communitylearninghub.ca/hub-splash-2020/assets/HUB-Privacy-Policy.pdf</a
              >
            </p>
          </li>
        </ol>
      </li>

      <li id="prohibited_use">
        <h3>PROHIBITED USES</h3>
        <ol>
          <li>
            <p>
              In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the
              Site or its content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any
              unlawful acts; (c) to violate any international, federal, provincial or state regulations, rules, laws, or
              local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual
              property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or
              discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or
              disability; (f) to submit false or misleading information; (g) to upload or transmit viruses or any other
              type of malicious code that will or may be used in any way that will affect the functionality or operation
              of the Service or of any related website, other websites, or the Internet; (h) to collect or track the
              personal information of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any
              obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Service or
              any related website, other websites, or the Internet.
            </p>
          </li>

          <li>
            <p>
              You may not modify, post, reproduce, distribute, copy, publish, display, transmit, adapt or in any way
              exploit the contents of the Site or the Services. You will use the Site, the Services any content and
              information comprising same solely for lawful purposes. You may not use spiders, robots, data mining
              techniques or other automated devices or programs to catalog, download or otherwise reproduce, store or
              distribute available content. You may not take any action to interfere with, or disrupt, the Site or its
              content, circumvent security measures or attempt to exceed the limited authorization and access granted to
              you under these Terms of Service. No permission is given to you to link or provide references to our Site
              and to use any of Springboard’s icon, site address, and trade-marks to provide such links or references,
              unless you have our prior written permission.
            </p>
          </li>
          <li>
            <p>
              We reserve the right to terminate your use of the Service or any related website for violating any of the
              prohibited uses.
            </p>
          </li>
          <li>
            <p>
              The Site and all of its content are protected by copyrights, trade-marks and other applicable intellectual
              property and proprietary laws and is owned, controlled, and/or licensed by Springboard and/or its
              affiliates or licensors. The Site and its contents are made available solely for your own personal,
              non-commercial and lawful use. Nothing contained on the Site should be considered as granting you, by
              implication, estoppel, or otherwise, any license or right to use any trade-marks, logos, or other names
              contained in the Site without the express prior written consent of the applicable rights holder.
            </p>
          </li>
        </ol>
      </li>

      <li id="liability_disclaimer">
        <h3>DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY</h3>
        <ol>
          <li>
            <p>
              We do not guarantee, represent or warrant that your use of our Service (including, without limitation, any
              software, content, products, services or other information comprising, or made available as part of, the
              Service) will be uninterrupted, timely, secure or error-free.
            </p>
          </li>
          <li>
            <p>
              We do not warrant that the results (including, without limitation, any content, products, services or
              other information) that may be obtained from the use of the Service will be accurate or reliable.
            </p>
          </li>
          <li>
            <p>
              You agree that from time to time we may remove the Service for indefinite periods of time or cancel the
              Service at any time, without notice to you.
            </p>
          </li>
          <li>
            <p>
              You expressly agree that your use of, or inability to use, the Service is at your sole risk. The Service
              and all products, services, content and information delivered to you through the Service are (except as
              expressly stated by us) provided 'as is' and 'as available' for your use, without any representation,
              warranties or conditions of any kind, either express or implied, including all implied warranties or
              conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title,
              and non-infringement.
            </p>
          </li>
          <li>
            <p>
              Springboard, its affiliates, licensors and their respective directors, officers, employees, consultants,
              agents, contractors, interns, suppliers, service providers and licensors expressly disclaim all
              warranties, including but not limited to warranties of fitness for a particular purpose, warranties of
              title and non-infringement and warranties of merchantability.
            </p>
          </li>
          <li>
            <p>
              In no case shall Operation Springboard, our directors, officers, employees, affiliates, agents,
              contractors, interns, suppliers, service providers or licensors be liable for any injury, loss,claim, or
              any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including,
              without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any
              similar damages, whether based in contract, tort (including negligence), strict liability or otherwise,
              arising from your use of any of the service or any products procured using the service, or for any other
              claim related in any way to your use of the service or any product, including, but not limited to, any
              errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of
              the service or any content (or product) posted, transmitted, or otherwise made available via the service,
              even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or
              the limitation of liability for consequential or incidental damages, in such states or jurisdictions, our
              liability shall be limited to the maximum extent permitted by law.
            </p>
          </li>
        </ol>
      </li>

      <li id="indemnification">
        <h3>INDEMNIFICATION</h3>
        <ol>
          <li>
            <p>
              As a condition of your use of the Site, and to the maximum extent permitted by applicable law, you will
              indemnify, defend and hold harmless Springboard and our parent, subsidiaries and affiliates and each of
              their respective partners, officers, directors, agents, contractors, licensors, service providers,
              subcontractors, suppliers, interns and employees, from any claim, demand, liability and expense, including
              reasonable attorneys’ fees, arising out of: (i) your breach of any provision of these Terms of Service or
              the documents they incorporate by reference; (ii) your use of the Site and any content contained in the
              Site; (iii) the submission of any comments by you; or (iv) your violation of any law or the rights of a
              third party.
            </p>
          </li>
        </ol>
      </li>

      <li id="severability">
        <h3>SEVERABILITY</h3>
        <ol>
          <li>
            <p>
              In the event that any provision of these Terms of Service is determined to be unlawful, void or
              unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by
              applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service,
              such determination shall not affect the validity and enforceability of any other remaining provisions.
            </p>
          </li>
        </ol>
      </li>

      <li id="termination">
        <h3>TERMINATION</h3>
        <ol>
          <li>
            <p>These Terms of Service are effective unless and until terminated by us.</p>
          </li>
          <li>
            <p>
              If in our sole judgment you fail, or we suspect that you have failed, to comply with any term or provision
              of these Terms of Service, we also may terminate your use of the Site and the Services at any time without
              notice to you.
            </p>
          </li>
        </ol>
      </li>

      <li id="entire_agreement">
        <h3>ENTIRE AGREEMENT</h3>
        <ol>
          <li>
            <p>
              The failure of us to exercise or enforce any right or provision of these Terms of Service shall not
              constitute a waiver of such right or provision.
            </p>
          </li>
          <li>
            <p>
              These Terms of Service and any policies or operating rules posted by us on this Site or in respect to the
              Service constitute the entire agreement and understanding between you and us and govern your use of the
              Service, superseding any prior or contemporaneous agreements, communications and proposals, whether oral
              or written, between you and us (including, but not limited to, any prior versions of the Terms of
              Service).
            </p>
          </li>
          <li>
            <p>
              Any ambiguities in the interpretation of these Terms of Service shall not be construed against the
              drafting party.
            </p>
          </li>
        </ol>
      </li>

      <li id="govering_law">
        <h3>GOVERING LAW</h3>
        <ol>
          <li>
            <p>
              These Terms of Service and any separate agreements whereby we provide you Services shall be governed by
              and construed in accordance with the laws of the Province of Ontario, Canada and the laws of Canada
              therein.
            </p>
          </li>
        </ol>
      </li>

      <li id="term_change">
        <h3>CHANGES TO TERMS OF: SERVICE</h3>
        <ol>
          <li>
            <p>
              You can review the most current version of the Terms of Service and Privacy Policy at any time on this
              page
              <a
                target="_blank"
                href="https://test.communitylearninghub.ca/hub-splash-2020/assets/HUB-Terms-of-Service.pdf"
                >https://test.communitylearninghub.ca/hub-splash-2020/assets/HUB-Terms-of-Service.pdf.</a
              >
            </p>
          </li>
          <li>
            <p>
              We reserve the right, at our sole discretion, to update, change or replace any part of these Terms of
              Service by posting updates and changes to our Website, each of which shall be effective immediately upon
              posting of the updates and changes to our Website. It is your responsibility to check our Website
              periodically for changes. Your continued use of or access to our Website or the Service following the
              posting of any changes to these Terms of Service constitutes acceptance of those changes.
            </p>
          </li>
        </ol>
      </li>

      <li id="contact_info">
        <h3>CONTACT INFORMATION</h3>
        <ol>
          <li>
            <p>
              Questions about the Terms of Service should be sent to us at
              <a target="_blank" href="mailto:hubinfo@springboardservices.ca">hubinfo@springboardservices.ca.</a>
            </p>
          </li>
        </ol>
      </li>
    </ol>

    <hr style="margin-top: 100px; margin-bottom: 100px" />

    <!-- Term of Service Section END -->

    <!-- Privacy Policy Section START-->
    <div style="text-align: center">
      <h2 styel>PRIVACY POLICY</h2>
    </div>
    <section id="overivew">
      <h3>OVERVIEW</h3>
      <p>
        The HUB is a not for profit, community of practice based initiative. The HUB community of practice initiative
        cannot succeed without contributions of utilization, implementation, satisfaction and feedback information from
        our partnering sites
        <strong>Springboard respects and values your participation in the HUB community of practice.</strong>
      </p>
      <p>
        When you login to the Community Learning HUB website, as part of your use of the HUB Service, we collect
        information about the parts of the HUB website you view, the HUB content you access and run, and the web links,
        videos, and documents you select, view and/or download
        <u>from within the HUB website.</u>
      </p>
      <p>
        The purpose of this document is
        <u>
          <i>to provide you with information you need to know</i>
        </u>
        about agreeing to the HUB’s Privacy Policy, acquiring a HUB website account, and participating in the HUB
        community of practice.
      </p>
    </section>

    <section id="consent">
      <h3>CONSENT</h3>
      <p>By using this site, you represent that you are at least the age of majority in your province of residence.</p>
      <p>
        Upon clicking to “accept” Springboard’s Community Learning HUB website’s Privacy Policy, you are agreeing to
        this privacy policy and granting Springboard permission to collect, store, access, use, analyze, generate
        reports about, and otherwise publish information regarding your access and utilization of the HUB website,
        including, information concerning:
      </p>
      <ul>
        <p>
          <u>
            <i>Personal Information:</i>
          </u>
        </p>
        <li>
          <p>
            • Your account information (i.e.: your name, work email, work phone number, work address, province, region,
            agency, supervisor and assigned HUB team)
          </p>
        </li>
        <p>
          <u>
            <i>Non-Personal Information:</i>
          </u>
        </p>
        <li>
          <p>• The times you logged into and out of the HUB website</p>
        </li>
        <li>
          <p>• The identified purposes for which you accessed HUB content (i.e.: training or delivery to clients)</p>
        </li>
        <li>
          <p>• The HUB content you accessed</p>
        </li>
        <li>
          <p>• The length of time you viewed HUB content</p>
        </li>
        <li>
          <p>
            <u>
              <i>Anonymous Information:</i>
            </u>
            pertaining to the clients you provide HUB services to, such as their age, gender, ethno-racial affiliation,
            referral path, the HUB content delivered, date and time of HUB delivery, duration of HUB delivery, and
            identified outcome of each client’s overall HUB experience. This data is used to report to government
            funders, private foundations and corporate sponsors who grant funds to Springboard’s Community Learning HUB.
            A full list of our funders and supporters is available at
            <a target="_blank" href="https://www.communitylearninghub.ca">https://www.communitylearninghub.ca</a>
            Additionally, the data is used within Springboard to track HUB utilization for Springboard’s Board of
            Directors, Annual Reports, communication products and to review and improve HUB’s user experience.
          </p>
        </li>
      </ul>
    </section>

    <section id="information_use">
      <h3>USE OF INFORMATION BY SPRINGBOARD</h3>
      <p>
        Springboard’s use of information pertaining to you and your use of the HUB website would always and only be, in
        the sole discretion of Springboard, for the purposes of:
      </p>
      <ul>
        <li>
          <p>
            • Understanding and demonstrating (to stakeholders and potential stakeholders) the parametres of HUB website
            utilization and implementation,
          </p>
        </li>
        <li>
          <p>
            • Identifying and demonstrating (to stakeholders and potential stakeholders) evidence-informed opportunities
            for the improvement of the HUB website, its content, facilitator training and program implementation.
          </p>
        </li>
      </ul>
      <p>
        We take reasonable precautions and follow industry best practices to protect your information and make sure it
        is not inappropriately lost, misused, accessed, disclosed, altered or destroyed. We will not sell your
        information.
      </p>
    </section>

    <section id="access_data">
      <h3>RIGHT TO ACCESS AND RECTIFY YOUR DATA</h3>
      <p>
        You may access and verify your personal information. Upon receipt of a written request, you will be informed,
        within a reasonable time following such request, of the existence, use and disclosure of your personal
        information. In order to safeguard personal information, we may need specific identification frorm you in order
        to verify your identity before we can provide you with the personal information we hold. There may be instances
        when we will not be able to provide you with the personal information that you request, for instance, if your
        personal information:
      </p>
      <ul>
        <li>
          <p>• contains references to other persons,</p>
        </li>
        <li>
          <p>
            • has already been destroyed due to legal requirements or because we no longer needed it for our purposes,
          </p>
        </li>
        <li>
          <p>• is subject to legal privilege,</p>
        </li>
        <li>
          <p>• contains confidential proprietary information, or</p>
        </li>
        <li>
          <p>• cannot be disclosed for other legal reasons.</p>
        </li>
      </ul>
    </section>

    <section id="activity_report">
      <h3>HUB ACTIVITY REPORTS PREPARED BY SPRINGBOARD</h3>
      <p>
        Springboard has access to all information pertaining to HUB utilization and implementation uploaded by
        facilitators from across the entire HUB Community of Practice; this includes information pertaining to the
        utilization and implementation of the HUB website at your organization and the details of all the HUB website
        activities you have directly participated in.
      </p>
      <ul>
        <li>
          <p>
            • The HUB website allows facilitators to view an individualized HUB activity report of all the HUB training
            events and HUB delivery events that they themselves have directly participated in
            <u>
              <i
                >Only the person who is the actual subject of the individual facilitator training/delivery report will
                have access to it.
              </i>
            </u>
          </p>
        </li>
        <li>
          <p>
            • Your organization’s leadership can request from Springboard an annual report of their organization’s
            record of HUB activity for the preceding fiscal year. Any such reports prepared by Springboard and shared
            with your organization’s leadership,
            <u>
              <i>would only feature anonymous facilitator and client information.</i>
            </u>
          </p>
        </li>
        <li>
          <p>
            • Springboard reserves the right, in its sole discretion, to prepare, share with stakeholders and publish
            reports of any organization’s record of HUB activity over any period of time.
          </p>
        </li>
        <li>
          <p>
            • By signing the HUB Privacy Policy, you agree to hold Springboard harmless should there be, in thought or
            in fact, any negative impacts to yourself, directly or indirectly as a result of Springboard’s decision to
            share and/or publish such reports.
          </p>
        </li>
      </ul>
    </section>

    <section id="opt_out">
      <h3>OPT-OUT</h3>
      <p>
        You may opt-out of the HUB community of practice and deactivate your HUB website account at any-time by sending
        us an email requesting deactivation of your account, to:
        <a target="_blank" href="mailto:hubinfo@springboardservices.ca">hubinfo@springboardservices.ca</a>
      </p>
      <p>
        You may also mail us a deactivation request at: Operation Springboard 2 Carlton Street, Suite 800, Toronto, ON,
        M5B-1J3.
      </p>
      <p>
        Upon receipt of such a request, Springboard will de-activate your account as soon as possible and your access to
        the HUB website will thereafter cease and the HUB website will no longer collect any further information related
        to you. We will then depersonalize any business contact information we had already collected in relation to your
        account, but will NOT remove any de-personalized information pertaining to your record of HUB activity (as to do
        so would distort the true record of your organization’s utilization of the HUB).
      </p>
    </section>

    <section id="email_marketing">
      <h3>EMAIL MARKETING</h3>
      <p>
        By accepting this privacy policy, you further grant us permission to send you messages about our Community
        Learning HUB service, the HUB community of practice, new HUB programs and other updates, to the email address
        you used to create your HUB website account.
      </p>
    </section>

    <section id="other_disclosure">
      <h3>OTHER DISCLOSURE</h3>
      <p>
        We may disclose your personal information if we are required by law to do so or if you violate our Terms of
        Service.
      </p>
    </section>

    <section id="third_party_service">
      <h3>THIRD-PARTY SERVICES</h3>
      <p>
        In general, the third-party providers used by us will only collect, use and disclose your information to the
        extent necessary to allow them to perform the services they provide to us. In particular, remember that certain
        providers may be located in or have facilities that are located in a different jurisdiction than either you or
        us.
      </p>
      <p>
        Once you leave our website or are redirected to a third-party website (eg.YouTube.com) or application, you are
        no longer governed by this Privacy Policy or our website’s Terms of Service. When you click on links on our
        website, they may direct you away from our site. We are not responsible for the privacy practices of other sites
        and encourage you to read their privacy statements.
      </p>
    </section>

    <section id="privacy_change">
      <h3>SECURITY</h3>
      <p>
        We have security measures in place to protect the loss, misuse and alteration of the information under our
        control. We have adopted appropriate safeguards to ensure that personal information is secure against
        disclosure, loss or theft or unauthorized access, copying, use or modification.
      </p>
    </section>

    <section id="data_retention">
      <h3>DATA RETENTION</h3>
      <p>
        We retain your personal data for so long as it is required to fulfil the activities set out in this privacy
        policy for as long as otherwise communicated to you or for so long as is permitted by applicable law.
      </p>
    </section>

    <section id="changes_to_policy">
      <h3>CHANGES TO THIS PRIVACY POLICY</h3>
      <p>
        We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and
        clarifications will take effect immediately upon their posting on the website. If we make material changes to
        this policy, we will notify you here that it has been updated, so that you are aware of what information we
        collect, how we use it, and under what circumstances, if any, we use and/or disclose it.
      </p>
      <p>You may review the latest version of the HUB Privacy Policy at:</p>
      <a target="_blank" href="https://test.communitylearninghub.ca/hub-splash-2020/assets/HUB-Privacy-Policy.pdf"
        >https://test.communitylearninghub.ca/hub-splash-2020/assets/HUB-Privacy-Policy.pdf</a
      >
    </section>

    <section id="contact_information">
      <h3>QUESTIONS AND CONTACT INFORMATION</h3>
      <p>
        If you would like to: access, correct, amend or delete any personal information we have about you, register a
        complaint, or simply want more information, email us at:
        <a target="_blank" href="mailto:hubinfo@springboardservices.ca">hubinfo@springboardservices.ca</a> or call us at
        the Springboard head office: (416) 977-0089, located at 2 Carlton Street, Suite 800, Toronto, ON, M5B-1J3,
        Canada
      </p>
    </section>
    <!-- Privacy Policy Section END -->
  </div>
</template>

<script>
export default {
  name: 'TOSHtml',
};
</script>

<style scoped>
ol {
  padding-left: 0;
  counter-reset: item;
}
ol li {
  display: table;
}
ol li:before {
  display: table-cell;
  box-sizing: border-box;
  padding-right: 0.8em;
  content: counters(item, '.') '.';
  counter-increment: item;
}
ol li p {
  word-break: break-all;
}
.underline {
  text-decoration: underline;
  font-style: italic;
}
.italic {
  font-style: italic;
}
</style>
